import React from 'react';
import { Building2, Cog, Factory, Rocket } from 'lucide-react';
import Reveal from '../saas/Reveal';

const ICONS = [Factory, Building2, Cog, Rocket];

/** مخاطبان هدف — کارت‌های ۲×۲ با آیکن و نشان تأیید (بدون شماره/بولت) */
export function IdealAudienceGrid({ items }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
      {items.map((text, i) => {
        const Icon = ICONS[i] || Rocket;
        return (
          <Reveal
            key={i}
            delayMs={i * 60}
            className="group relative flex flex-col items-center rounded-[1.25rem] border border-hairline/40 bg-card-surface/95 p-6 text-center shadow-saas backdrop-blur-[2px] transition duration-300 hover:border-signal/30 hover:shadow-saas-md sm:p-7"
          >
            <div className="mb-4 flex justify-center sm:mb-5">
              <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-wash to-card-surface text-signal shadow-saas ring-1 ring-hairline/40 transition duration-300 group-hover:scale-[1.04] group-hover:ring-signal/30 sm:h-16 sm:w-16">
                <Icon className="h-7 w-7 stroke-[1.85] sm:h-8 sm:w-8" aria-hidden strokeLinecap="round" strokeLinejoin="round" />
              </div>
            </div>
            <p className="text-[0.9375rem] font-medium leading-[1.75] tracking-normal text-ink-graphite sm:text-base">{text}</p>
          </Reveal>
        );
      })}
    </div>
  );
}
